import { HeadingTitle } from "../ModalContainer";
import secureLocalStorage from "react-secure-storage";
import { Button } from "@material-ui/core";
import Dropdown from "../../Dropdown/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  CreateBoxActions,
  saveBoxTypeActions,
} from "../../../Actions/ProductionActions";
import { filterById } from "../../../Middleware/CommonFun";
import Loading from "../../Loading/Loading";

const CreateBox = ({
  close,
  inventory_id,
  sub_location_id,
  has_single_sku,
  handleBoxCreated,
  from_Location_id,
  to_Location_id,
  party_id
}) => {
  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  const dispatch = useDispatch();

  // Box Type State
  const { saveBoxType, loading } = useSelector((state) => state.SaveGetBoxType);

  //   create Box State
  const { create_Box, loading: createBoxLoading } = useSelector(
    (state) => state.createBox
  );

  useEffect(() => {
    dispatch(saveBoxTypeActions("save_box_type", token, false));
  }, [dispatch, token]);

  const [BoxTypes, setBoxTypes] = useState([]);

  const [selectedBoxType, setSelectedBoxType] = useState(null);

  useEffect(() => {
    if (saveBoxType && saveBoxType?.status === 1) {
      const FormattedBoxType = saveBoxType?.box_types?.map((item) => {
        const { id, name, is_default } = item.BoxType;
        return {
          id,
          label: name,
          value: name,
          is_default: is_default === "1",
        };
      });
      setBoxTypes(FormattedBoxType);

      const defaultBox = FormattedBoxType.find(
        (box) => box.is_default === true
      );
      if (defaultBox) {
        setSelectedBoxType(defaultBox.id);
      }
    }
  }, [saveBoxType]);

  console.log("Box TYPE: ", saveBoxType);

  const handleBoxType = (val) => {
    setSelectedBoxType(val?.id);
  };

  const [isBoxCreated, setIsBoxCreated] = useState(false);

  const handleSubmit = () => {
    setIsBoxCreated(true);
    dispatch(
      CreateBoxActions(
        "inventory_create_box",
        inventory_id,
        sub_location_id,
        has_single_sku,
        selectedBoxType,
        token,
        from_Location_id,
        to_Location_id,
        party_id
      )
    );
  };

  useEffect(() => {
    if (create_Box && create_Box?.status === 1 && isBoxCreated) {
      handleBoxCreated(1);
      setIsBoxCreated(false);
    }
    if (create_Box && create_Box?.status === 0 && isBoxCreated) {
      handleBoxCreated(0);
      setIsBoxCreated(false);
    }
    // eslint-disable-next-line
  }, [create_Box, isBoxCreated]);

  return (
    <div>
      <HeadingTitle title={`Create Box`} center={false} closeModal={close} />
      {loading ? (
        <div className="mtx-3">
          <Loading color={"#1c1c1c"} size={38} />
        </div>
      ) : (
        <>
          <div className="mtx5-3">
            <Dropdown
              dropdown={BoxTypes}
              placeholder="Select Box Type"
              label="Select Box Type"
              value={filterById(BoxTypes, selectedBoxType)}
              onData={(value) => handleBoxType(value)}
            />
          </div>
          <div className="center__cta text-center">
            <Button
              className="add-btn"
              onClick={handleSubmit}
              style={{ backgroundColor: "#3C94C6" }}
            >
              {createBoxLoading ? (
                <Loading color={"#ffffff"} size={18} />
              ) : (
                "Create"
              )}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default CreateBox;
